if(window.Maximize.checkFileNotLoaded()) {
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xMediaGalleryQuickView', (mediaGalleryWrapperEle, sectionId, zoomEffect, navigationButtonStyle, isShowMediaWithVariantSelected, ratioSettings, isQuickView, firstMediaId) => ({
        isFirstLoading: true,
        swiffySlider: null,
        thumbnailItems: [],
        thumbnailItemsShow: [],
        listZoomThumbnailItems : [],
        listZoomThumbnailItemsShow : [],
        isShowZoomThumbnail: true,
        mediaItems: [],
        mediaItemsShow: [],
        indexActiveThumbnail: 0,
        indexActiveMedia: 0,
        activeMediaId: false,
        zoomItemActiveMediaId: false,
        activeMediaItem: false,
        isZoomOpen: false,
        isShowZoomLargeSlide: false,
        listMediaApplyShowMediaWithVariantSelected: [],
        productMediasInfo: [],
        currentVariant: false,
        listZoomItemsEnlarge: [],
        listZoomItemsEnlargeShow: [],
        sliderIndicatorWrapperEle: mediaGalleryWrapperEle.querySelector('.slider-indicators'),
        init() {
          this.sectionContainer = document.querySelector(`.section--${sectionId}`);
          if (!this.sectionContainer) {
            this.sectionContainer = document.querySelector(`.main-product__container--${sectionId}`);
          }
          if (this.sectionContainer) {
            this.thumbnailWrapper = this.sectionContainer.querySelector(`.media-gallery__thumbnail-wrapper`);
            this.mediaWrapper = this.sectionContainer.querySelector(`.media-gallery__container`);
            this.thumbnailItems = this.sectionContainer.querySelectorAll('.media-gallery__thumbnail-item');
            this.thumbnailItemsShow = this.sectionContainer.querySelectorAll('.media-gallery__thumbnail-item.is-show-thumbnail-item');
            this.mediaItems = this.sectionContainer.querySelectorAll('.media-gallery__media-item');
            this.mediaItemsShow = this.sectionContainer.querySelectorAll('.media-gallery__media-item.is-show-media-item');
            this.listIndicatorEle = this.sliderIndicatorWrapperEle ? this.sliderIndicatorWrapperEle.querySelectorAll(`.slider-indicator`) : [];

            if (this.thumbnailWrapper) {
              this.thumbnailContainer = this.thumbnailWrapper.querySelector('.media-gallery__thumbnail-container');
            }

            let indexActiveMedia = Array.from(this.mediaItems).findIndex(item => item.classList.contains('is-active'));
            this.indexActiveMedia = indexActiveMedia >= 0 ? indexActiveMedia : 0;
            this.activeMediaItem = this.mediaItems[this.indexActiveMedia];
            this.activeMediaId = this.mediaItems[this.indexActiveMedia].dataset.mediaId;
            
            requestAnimationFrame(() => {
              this.__updateActiveItemZoomEnlarge();
              // this.__updateHeightWhenRatioNatural();
            })
          }
          const productMediaInfoEle = document.querySelector(`#ProductMediaInfo__${sectionId}`);
          if (productMediaInfoEle) {
            this.productMediasInfo = JSON.parse(productMediaInfoEle.textContent);
          }
          this.currentVariantInfoElement = document.querySelector(`#CurrentVariantInfo__${sectionId}`);
          this.currentVariant = JSON.parse(this.currentVariantInfoElement.textContent);

          this.$watch('activeMediaId', (newActiveMediaId, oldActiveMediaId) => {
            const oldMediaItem =  Array.from(this.mediaItems).find(item => parseInt(item.dataset.mediaId) === oldActiveMediaId);
            if (oldMediaItem) {
              oldMediaItem.style.backgroundImage = ``;
              const media = oldMediaItem.querySelector('.media-gallery-item__media');
              if (media) {
                media.classList.remove('hidden');
              }
            }
            this.isZoomOpen = false;
            if (zoomEffect === ZOOM_EFFECT.magnifier) {
              this.__handleCloseZoom();
            }
            // this.indexActiveThumbnail = newValue;
            this.__scrollThumbnail();
            this.__updateActiveItemZoomEnlarge();
            // this.__updateHeightWhenRatioNatural();
            this.mediaItems.forEach(mediaItem => {
              const videoContainer = mediaItem.querySelector('.external-video');

              if (mediaItem.dataset.mediaId == newActiveMediaId) {
                this.activeMediaItem = mediaItem;
                mediaItem.classList.add('is-active');
                if (videoContainer) {
                  Alpine.store('xVideo').updateStatusVideo(videoContainer, true)
                }
              } else {
                mediaItem.classList.remove('is-active');
                if (videoContainer) {
                  Alpine.store('xVideo').updateStatusVideo(videoContainer, false)
                }
              }
            })
            this.thumbnailItemsShow.forEach(thumbnailItem => {
              if (thumbnailItem.dataset.mediaId == newActiveMediaId) {
                thumbnailItem.classList.add('is-active');
              } else {
                thumbnailItem.classList.remove('is-active');
              }
            })
            this.listIndicatorEle = this.sliderIndicatorWrapperEle ? this.sliderIndicatorWrapperEle.querySelectorAll(`.slider-indicator`) : [];
            this.listIndicatorEle.forEach(indicator => {
              if (indicator.dataset.mediaId == newActiveMediaId) {
                indicator.classList.add('active');
              } else {
                indicator.classList.remove('active');
              }
            })
            const newIndexActiveSlide = Array.from(this.swiffySlider.slides).findIndex(item => item.dataset.mediaId === newActiveMediaId);
            this.swiffySlider.slideTo(newIndexActiveSlide);
          })

          requestAnimationFrame(() => {
            if (this.$refs.thumbnail_wrapper) {
              const listThumbnailShow = this.$refs.thumbnail_wrapper.querySelectorAll(`.media-gallery__thumbnail-item.is-show-thumbnail-item`);

              if (listThumbnailShow.length > 1) {
                this.$refs.thumbnail_wrapper.classList.add('is-show');
              } else {
                this.$refs.thumbnail_wrapper.classList.remove('is-show');
              }
              this.__updateShowThumbnailNav();
              this.__scrollThumbnail();
            }
          });

          this.$watch('listMediaApplyShowMediaWithVariantSelected', (newList) => {
            const newListString = newList.map(String);
            if (this.$refs.thumbnail_wrapper) {
              if (newList.length > 1) {
                this.$refs.thumbnail_wrapper.classList.add('is-show');
              } else {
                this.$refs.thumbnail_wrapper.classList.remove('is-show');
              }
            }

            this.mediaItems.forEach(mediaItem => {
              if (newListString.includes(mediaItem.dataset.mediaId)) {
                mediaItem.classList.add('is-show-media-item');
              } else {
                mediaItem.classList.remove('is-show-media-item');
              }
            })
            this.mediaItemsShow = this.sectionContainer.querySelectorAll('.media-gallery__media-item.is-show-media-item');
            this.thumbnailItems.forEach(thumbnailItem => {
              if (newListString.includes(thumbnailItem.dataset.mediaId)) {
                thumbnailItem.classList.add('is-show-thumbnail-item');
              } else {
                thumbnailItem.classList.remove('is-show-thumbnail-item');
              }
            })
            this.thumbnailItemsShow = this.sectionContainer.querySelectorAll('.media-gallery__thumbnail-item.is-show-thumbnail-item');
            this.__scrollThumbnail();
            this.__updateShowThumbnailNav();
            this.listIndicatorEle = this.sliderIndicatorWrapperEle ? this.sliderIndicatorWrapperEle.querySelectorAll(`.slider-indicator`) : [];
            this.listIndicatorEle.forEach(indicator => {
              if (newListString.includes(indicator.dataset.mediaId)) {
                indicator.classList.add('is-show-indicator');
              } else {
                indicator.classList.remove('is-show-indicator'); 
              }
            })
            this.zoomEnlargeWrapperEle = document.querySelector(`#MediaGalleryZoom__Enlarge__${sectionId}`);
            if (this.zoomEnlargeWrapperEle) {
              this.zoomEnlargeThumbnailWrapper = this.zoomEnlargeWrapperEle.querySelector('.zoom-enlarge__thumbnail-wrapper');
              this.zoomEnlargeThumbnailContainer = this.zoomEnlargeWrapperEle.querySelector('.zoom-enlarge__thumbnail-container');
              
              this.listZoomItemsEnlarge = this.zoomEnlargeWrapperEle.querySelectorAll(`.media-gallery__zoom-enlarge__item`);
              this.listZoomItemsEnlargeShow = this.zoomEnlargeWrapperEle.querySelectorAll(`.media-gallery__zoom-enlarge__item.is-show-media-zoom-item`);
              this.listZoomThumbnailItems = this.zoomEnlargeWrapperEle.querySelectorAll(`.zoom-enlarge__thumbnail-item`);
              this.listZoomThumbnailItemsShow = this.zoomEnlargeWrapperEle.querySelectorAll(`.zoom-enlarge__thumbnail-item.is-show-media-zoom-item`);
            }

            this.listZoomItemsEnlarge.forEach(zoomItem => {
              if (newListString.includes(zoomItem.dataset.mediaId)) {
                zoomItem.classList.add('is-show-media-zoom-item');
              } else {
                zoomItem.classList.remove('is-show-media-zoom-item');
              }
            })

            this.listZoomThumbnailItems.forEach(zoomThumbnailItem => {
              if (newListString.includes(zoomThumbnailItem.dataset.mediaId)) {
                zoomThumbnailItem.classList.add('is-show-media-zoom-item');
              } else {
                zoomThumbnailItem.classList.remove('is-show-media-zoom-item');
              }
            })

            if (this.zoomEnlargeWrapperEle) {
              this.listZoomItemsEnlargeShow = this.zoomEnlargeWrapperEle.querySelectorAll(`.media-gallery__zoom-enlarge__item.is-show-media-zoom-item`);
              this.listZoomThumbnailItemsShow = this.zoomEnlargeWrapperEle.querySelectorAll(`.zoom-enlarge__thumbnail-item.is-show-media-zoom-item`);
            }

            if (this.swiffySlider) {
              this.swiffySlider.slides = mediaGalleryWrapperEle.querySelectorAll('.slide-item.is-show-media-item');
              this.swiffySlider.sliderIndicators = mediaGalleryWrapperEle.querySelectorAll(`.slider-indicator.is-show-indicator`);
              const indexActive = Array.from(this.swiffySlider.slides).findIndex(item => item.dataset.mediaId === this.activeMediaId);

              if (indexActive > -1) {
                this.swiffySlider.slideTo(indexActive);
              }
              this.swiffySlider.addEventToIndicators();
            }

            if (this.swiffySlideZoomLarge) {
              this.swiffySlideZoomLarge.slides = this.zoomEnlargeWrapperEle.querySelectorAll(`.media-gallery__zoom-enlarge__item.is-show-media-zoom-item`);
              
              this.swiffySlideZoomLarge.sliderNavs.forEach((nav) => {
                nav.classList[this.swiffySlideZoomLarge.slidesPerView > 0 && this.swiffySlideZoomLarge.slidesPerView < this.swiffySlideZoomLarge.slides.length ? "add" : "remove"]("is-visible");
              });
            }
          })
          this.handleChangeVariant();
          const debounce = (callback, delay) => {
            let timer;
            return function() {
              clearTimeout(timer);
              timer = setTimeout(callback, delay);
            };
          };

          window.addEventListener('resize', debounce(() => {
            this.__updateShowThumbnailNav();
            this.__scrollZoomEnlargeThumbnail();
          }, 300));

          this.$watch('zoomItemActiveMediaId', () => {
            this.__scrollZoomEnlargeThumbnail();
          })
        },
        handleInitSwiffy(el, configs) {
          this.isFirstLoading = false;

          this.swiffySlider = new SwiffySlider(el, configs);
          this.mediaItems = this.sectionContainer.querySelectorAll('.media-gallery__media-item');
          this.mediaItemsShow = this.sectionContainer.querySelectorAll('.media-gallery__media-item.is-show-media-item');

          document.addEventListener(`${PRODUCT_EVENT.updatedVariant}${sectionId}`, (event) => {
            const {currentVariant} = event.detail;
            this.currentVariant = currentVariant;

            this.handleChangeVariant(event);
          });

          el.addEventListener(`${SWIFFY_SLIDER_EVENT.slide}`, (event) => {
            const {newActiveSlideIndex} = event.detail;
            if (this.swiffySlider.slides[this.swiffySlider.activeSlideIndex]) {
              this.activeMediaId = this.swiffySlider.slides[this.swiffySlider.activeSlideIndex].dataset.mediaId;
            }
          })
          if (!this.mediaWrapper) {
            this.sectionContainer = document.querySelector(`.section--${sectionId}`);
            if (!this.sectionContainer) {
              this.sectionContainer = document.querySelector(`.main-product__container--${sectionId}`);
            }
            if (this.sectionContainer) {
              this.mediaWrapper = this.sectionContainer.querySelector(`.media-gallery__container`);
            }
          }
          if (this.mediaWrapper) {
            if (
              (navigationButtonStyle === 'mobile_only' && window.innerWidth > MIN_DEVICE_WIDTH.tablet)
              || (navigationButtonStyle === 'none' && window.innerWidth > MIN_DEVICE_WIDTH.tablet)
            ) {
              if (!isQuickView) {
                this.mediaWrapper.addEventListener('wheel', this.handleWheel.bind(this));
              }
            }
          }
        },
        handleClickThumbnailNav: function (event, isNext) {
          const totalItemsShow = this.thumbnailItemsShow.length;
          let indexActiveThumbnail = Array.from(this.thumbnailItemsShow).findIndex(item => item.dataset.mediaId == this.activeMediaId)

          while (true) {
            indexActiveThumbnail += isNext ? 1 : -1;
            if (indexActiveThumbnail < 0) {
              indexActiveThumbnail = totalItemsShow - 1;
            } else if (indexActiveThumbnail >= totalItemsShow) {
              indexActiveThumbnail = 0;
            }

            this.activeMediaId = this.thumbnailItemsShow[indexActiveThumbnail].dataset.mediaId;
            break;
          }
        },
        handleFocusThumbnail: function (event) {
          const thumbnailItem = event.currentTarget;
          this.activeMediaId = thumbnailItem.dataset.mediaId;
        },
        handleFocusZoomEnlargeThumbnail () {
          const newZoomItemActiveMediaId = this.$el.dataset.mediaId
          const indexActiveZoomItem = Array.from(this.swiffySlideZoomLarge.slides).findIndex(item => item.dataset.mediaId === newZoomItemActiveMediaId);
          if (indexActiveZoomItem > -1) {
            this.swiffySlideZoomLarge.slideTo(indexActiveZoomItem);

            if (this.listZoomThumbnailItemsShow.length > 0) {
              this.zoomItemActiveMediaId = newZoomItemActiveMediaId;
              
              const newActiveItem = this.swiffySlideZoomLarge.slides[indexActiveZoomItem];
              if (newActiveItem && (newActiveItem.dataset.mediaType == 'video' || newActiveItem.dataset.mediaType == 'external_video')) {
                const videoContainer = newActiveItem.getElementsByClassName('external-video')[0];
                if (!videoContainer) return;
                const thumbnailVideo = videoContainer.getElementsByClassName('media-gallery-item__img-thumbnail')[0];
                if (thumbnailVideo && !thumbnailVideo.classList.contains('hidden')) {
                  thumbnailVideo.focus();
                } else {
                  const buttonPlay = videoContainer.getElementsByClassName('button-play')[0];
                  if (buttonPlay) {
                    buttonPlay.focus();
                  } else {
                    if (newActiveItem.dataset.mediaType == 'external_video') {
                      videoContainer.focus();
                    } else {
                      const video = videoContainer.getElementsByClassName("video")[0];
                      if (!video) return;
                      video.focus();
                    }
                  }
                }
              }
            }
          }
        },
        handleWheel(event) {
          if (window.innerWidth < MIN_DEVICE_WIDTH.tablet) return;
          const mediaItem = Array.from(this.mediaItems).find(item => item.dataset.mediaId == this.activeMediaId)
          if (mediaItem && mediaItem.dataset.mediaType === 'model') return;

          event.preventDefault();
          event.stopPropagation();

          if (this.isWheelBlocked) return;
          this.isWheelBlocked = true;

          const length = this.mediaItemsShow.length;
          if (length === 0) return;
          const currentIndexMediaItem = Array.from(this.mediaItemsShow).findIndex(mediaItem => mediaItem.dataset.mediaId == this.activeMediaId);
          if (currentIndexMediaItem > -1) {
            const direction = event.deltaY > 0 ? 1 : -1;
            let newIndex = (currentIndexMediaItem + direction + length) % length;
            if (newIndex >= this.mediaItemsShow.length) {
              newIndex = 0;
            } else if (newIndex < 0) {
              newIndex = this.mediaItemsShow.length - 1;
            }            
            this.activeMediaId = this.mediaItemsShow[newIndex].dataset.mediaId;
            const newThumbnailItemsActive = Array.from(this.thumbnailItemsShow).find(item => item.dataset.mediaId === this.activeMediaId);
            if (newThumbnailItemsActive) {
              newThumbnailItemsActive.click()
            }
          }
          setTimeout(() => {
            this.isWheelBlocked = false;
          }, 1000)
        },
        handleChangeVariant(event) {
          let listMediaApplyShowMediaWithVariantSelected = [];
          let listMediaNullAlt = [];

          if (isShowMediaWithVariantSelected && this.currentVariant && this.currentVariant.options[0]) {
            let activeMediaId = false;

            let firstOptionHandleCurrentVariant = this.currentVariant.options[0].toLowerCase().replace(/ /g,'-');
            this.mediaItems.forEach(item => {
              if (item.dataset.mediaAlt !== '') {
                let mediaAltHandle = item.dataset.mediaAlt;
                if (firstOptionHandleCurrentVariant === mediaAltHandle) {
                  if (!activeMediaId) {
                    activeMediaId = item.dataset.mediaId;
                  }

                  listMediaApplyShowMediaWithVariantSelected.push(item.dataset.mediaId);
                }
              } else  {
                listMediaNullAlt.push(item.dataset.mediaId);
              }
            })
            if (!activeMediaId) {
              if (this.currentVariant.featured_media && this.currentVariant.featured_media.id) {
                activeMediaId = this.currentVariant.featured_media.id.toString();
              } else {
                activeMediaId = this.productMediasInfo[0].id.toString();
              }
            }
            listMediaApplyShowMediaWithVariantSelected.push(activeMediaId);
            this.activeMediaId = activeMediaId;
            
            listMediaApplyShowMediaWithVariantSelected = listMediaApplyShowMediaWithVariantSelected.concat(listMediaNullAlt);
          } else {
            if (event) {
              let featuredMediaId = `${event.detail.previewMediaId}`;

              if (this.currentVariant && this.currentVariant.featured_media && this.currentVariant.featured_media.id) {
                featuredMediaId = `${this.currentVariant.featured_media.id}`;
              }
              this.activeMediaId = featuredMediaId.toString();
            }

            this.productMediasInfo.forEach(media => {
              listMediaApplyShowMediaWithVariantSelected.push(media.id);
            })
          }

          this.listMediaApplyShowMediaWithVariantSelected = [...new Set(listMediaApplyShowMediaWithVariantSelected)];
          if (this.sliderIndicatorWrapperEle) {
            if (this.listMediaApplyShowMediaWithVariantSelected.length > 1) {
              this.sliderIndicatorWrapperEle.classList.remove('invisible');
            } else {
              this.sliderIndicatorWrapperEle.classList.add('invisible');
            }
          }
        },
        __scrollZoomEnlargeThumbnail() {
          if (this.zoomEnlargeThumbnailContainer) {
            const gap = parseInt(window.getComputedStyle(this.zoomEnlargeThumbnailContainer).gap) || 0;
            let indexActiveThumbnail = 0;
            this.listZoomThumbnailItemsShow.forEach((item, index) => {
              if (item.dataset.mediaId === this.zoomItemActiveMediaId) {
                item.classList.add('is-active');
                indexActiveThumbnail = index;
                if (item.dataset.mediaType == 'external_video' || item.dataset.mediaType == 'video') {
                  this.isShowZoomThumbnail = false
                } else {
                  this.isShowZoomThumbnail = true
                }
              } else {
                item.classList.remove('is-active');
              }
            })

            let scrollLeftValue = 0;
            if (indexActiveThumbnail > 0) {
              for (let i = 0; i < indexActiveThumbnail; i++) {
                if (this.listZoomThumbnailItemsShow[i]) {
                  scrollLeftValue += this.listZoomThumbnailItemsShow[i].offsetWidth + gap;
                }
              }
            }
            if (window.Maximize.rtl) {
              scrollLeftValue = scrollLeftValue * -1;
            }

            this.zoomEnlargeThumbnailWrapper.scrollTo({
              left: scrollLeftValue,
              behavior: 'smooth'
            });
          }
        },
        __scrollThumbnail: function () {
          if (this.thumbnailContainer) {
            const gap = parseInt(window.getComputedStyle(this.thumbnailContainer).gap) || 0;
            this.thumbnailItems.forEach((item, index) => {
              if (item.dataset.mediaId === this.activeMediaId) {
                item.classList.add('is-active');
              } else {
                item.classList.remove('is-active');
              }
            })
            const indexActiveThumbnail = Array.from(this.thumbnailItemsShow).findIndex(item => item.dataset.mediaId === this.activeMediaId);
            if (window.innerWidth >= MIN_DEVICE_WIDTH.tablet) {
              let scrollTopValue = 0;
              if (indexActiveThumbnail > 0) {
                for (let i = 1; i <= indexActiveThumbnail; i++) {
                  scrollTopValue += this.thumbnailItemsShow[i].offsetHeight + gap;
                }
              }

              this.thumbnailWrapper.scrollTo({
                top: scrollTopValue,
                behavior: 'smooth'
              });
            } else {
              let scrollLeftValue = 0;
              if (indexActiveThumbnail > 0) {
                for (let i = 0; i < indexActiveThumbnail; i++) {
                  scrollLeftValue += this.thumbnailItemsShow[i].offsetWidth + gap;
                }
              }
              if (window.Maximize.rtl) {
                scrollLeftValue = scrollLeftValue * -1;
              }

              this.thumbnailWrapper.scrollTo({
                left: scrollLeftValue,
                behavior: 'smooth'
              });
            }
          }
        },
        handleZoom: function () {
          // const mediaItem = event.target.closest('.media-gallery__media-item');
          if (this.activeMediaItem) {
            if (this.activeMediaItem.dataset.mediaType !== 'image') return;
            if (this.isZoomOpen) {
              this.__handleCloseZoom();
            } else {
              this.__handleOpenZoom();
            }
          }
        },
        __handleOpenZoom: function () {
          if (this.activeMediaItem && this.activeMediaItem.dataset.mediaType !== 'image') return;
          this.isZoomOpen = true;
          mediaGalleryWrapperEle.classList.add('is-open-zoom');

          const handleOpenZoomEnlargeEffect = () => {
            document.body.classList.add("overflow-hidden");
          }
          const handleOpenZoomMagnifierEffect = () =>  {
            if (this.activeMediaItem) {
              this.activeMediaItem.classList.add('is-zoom-media');
              const media = this.activeMediaItem.querySelector('.media-gallery__item__image');

              if (media) {
                this.activeMediaItem.style.backgroundImage = `url('${media.src}')`;

                this.mediaWrapper.addEventListener('mousemove', this.handleZoomWhenHoverImage.bind(this));
                media.classList.add('hidden');
              }
            }
          }

          if (window.innerWidth >= MIN_DEVICE_WIDTH.desktop) {
            if (zoomEffect === ZOOM_EFFECT.enlarge) {
              handleOpenZoomEnlargeEffect();
            } else if (zoomEffect === ZOOM_EFFECT.magnifier) {
              handleOpenZoomMagnifierEffect();
            }
          } else {
            if (zoomEffect === ZOOM_EFFECT.enlarge || zoomEffect === ZOOM_EFFECT.magnifier) {
              handleOpenZoomEnlargeEffect();
            }
          }

        },
        __handleCloseZoom: function () {
          this.isZoomOpen = false;
          mediaGalleryWrapperEle.classList.remove('is-open-zoom');

          const handleCloseZoomEnlargeEffect = () => {
            document.body.classList.remove("overflow-hidden");
            Alpine.store('xFocusElement').removeTrapFocus();
            // this.swiffySlideZoomLarge = false;
            this.__updateActiveItemZoomEnlarge();
          }

          const handleCloseZoomMagnifierEffect = () => {
            if (this.activeMediaItem) {
              this.activeMediaItem.classList.remove('is-zoom-media');
              const media = this.activeMediaItem.querySelector('.media-gallery-item__media');

              if (media) {
                this.activeMediaItem.style.backgroundImage = ``;

                this.mediaWrapper.removeEventListener('mousemove', this.handleZoomWhenHoverImage);
                media.classList.remove('hidden');
              }
            }
          }
          this.__updateActiveItemZoomEnlarge();
          if (window.innerWidth >= MIN_DEVICE_WIDTH.desktop) {
            if (zoomEffect === ZOOM_EFFECT.enlarge) {
              handleCloseZoomEnlargeEffect();
            } else if (zoomEffect === ZOOM_EFFECT.magnifier) {
              handleCloseZoomMagnifierEffect();
            }
          } else {
            if (zoomEffect === ZOOM_EFFECT.enlarge || zoomEffect === ZOOM_EFFECT.magnifier) {
              handleCloseZoomEnlargeEffect();
            }
          }
        },
        handleZoomWhenHoverImage: function (event) {
          const offsetX = event.offsetX ? event.offsetX : (event.touches && event.touches[0] ? event.touches[0].pageX : 0);
          const offsetY = event.offsetY ? event.offsetY : (event.touches && event.touches[0] ? event.touches[0].pageY : 0);

          const x = (offsetX / this.activeMediaItem.offsetWidth) * 100;
          const y = (offsetY / this.activeMediaItem.offsetHeight) * 100;
          this.activeMediaItem.style.backgroundPosition = `${x}% ${y}%`;
        },
        handleInitZoomEffectEnlarge: function (el, configs) {
          if (this.swiffySlideZoomLarge) {

          } else {
            let updatedConfig = {...configs}
            this.swiffySlideZoomLarge = new SwiffySlider(el, updatedConfig);
          }

          el.addEventListener(`${SWIFFY_SLIDER_EVENT.slide}`, (event) => {
            if (event.target.classList.contains('zoom-enlarge__wrapper')) {
              const newActiveSlideIndex = event.detail.newActiveSlideIndex
              this.zoomItemActiveMediaId = this.listZoomItemsEnlargeShow[newActiveSlideIndex].dataset.mediaId
            }
          })

          this.zoomEnlargeWrapperEle = document.querySelector(`#MediaGalleryZoom__Enlarge__${sectionId}`);
          if (this.zoomEnlargeWrapperEle) {
            this.zoomEnlargeThumbnailWrapper = this.zoomEnlargeWrapperEle.querySelector('.zoom-enlarge__thumbnail-wrapper');
            this.zoomEnlargeThumbnailContainer = this.zoomEnlargeWrapperEle.querySelector('.zoom-enlarge__thumbnail-container');

            this.listZoomItemsEnlarge = this.zoomEnlargeWrapperEle.querySelectorAll(`.media-gallery__zoom-enlarge__item`);
            this.listZoomItemsEnlargeShow = this.zoomEnlargeWrapperEle.querySelectorAll(`.media-gallery__zoom-enlarge__item.is-show-media-zoom-item`);
            this.listZoomThumbnailItems = this.zoomEnlargeWrapperEle.querySelectorAll(`.zoom-enlarge__thumbnail-item`);
            this.listZoomThumbnailItemsShow = this.zoomEnlargeWrapperEle.querySelectorAll(`.zoom-enlarge__thumbnail-item.is-show-media-zoom-item`);
          }

          const indexActiveZoomItem = Array.from(this.swiffySlideZoomLarge.slides).findIndex(item => item.dataset.mediaId === this.activeMediaId);
          if (indexActiveZoomItem > -1) {
            this.swiffySlideZoomLarge.slideTo(indexActiveZoomItem);
            if (this.listZoomThumbnailItemsShow.length > 0) {
              const newZoomItemActiveMediaId = this.listZoomThumbnailItemsShow[indexActiveZoomItem]?.dataset?.mediaId
              this.zoomItemActiveMediaId = newZoomItemActiveMediaId
            }
          }
        },
        __updateActiveItemZoomEnlarge() {
          this.zoomEnlargeWrapperEle = document.querySelector(`#MediaGalleryZoom__Enlarge__${sectionId}`);
          if (this.zoomEnlargeWrapperEle) {
            this.zoomEnlargeThumbnailWrapper = this.zoomEnlargeWrapperEle.querySelector('.zoom-enlarge__thumbnail-wrapper');
            this.zoomEnlargeThumbnailContainer = this.zoomEnlargeWrapperEle.querySelector('.zoom-enlarge__thumbnail-container');

            this.listZoomItemsEnlarge = this.zoomEnlargeWrapperEle.querySelectorAll(`.media-gallery__zoom-enlarge__item`);
            this.listZoomThumbnailItems = this.zoomEnlargeWrapperEle.querySelectorAll(`.zoom-enlarge__thumbnail-item`);
          }

          this.listZoomItemsEnlarge.forEach((item, index) => {
            if (item.dataset.mediaId === this.activeMediaId) {
              item.classList.add('is-active');
            } else {
              item.classList.remove('is-active');
            }
          });
        },
        // __updateHeightWhenRatioNatural() {
        //   if (ratioSettings === 'natural') {
        //     if (this.mediaItems[this.indexActiveMedia] && this.mediaItems[this.indexActiveMedia].dataset.ratio) {
        //       const mediaSwiffyContainer = mediaGalleryWrapperEle.querySelector(`.slider-container`);
        //       if (mediaSwiffyContainer) {
        //         mediaSwiffyContainer.style.setProperty("--swiffy-slider-item-ratio", parseFloat(this.mediaItems[this.indexActiveMedia].dataset.ratio));
        //       }
        //     }
        //     const sliderNavWrapperEle = mediaGalleryWrapperEle.querySelector('.slider-nav__wrapper');
        //     if (sliderNavWrapperEle) {
        //       sliderNavWrapperEle.classList.remove('invisible');
        //     }

        //     if (this.sliderIndicatorWrapperEle) {
        //       this.sliderIndicatorWrapperEle.classList.remove('invisible');
        //     }
        //   }
        // },
        __updateShowThumbnailNav() {
          if (this.$refs.thumbnail_wrapper) {
            const thumbnailNavs = this.$refs.thumbnail_wrapper.querySelectorAll('.media-gallery__thumbnail-nav');
            this.thumbnailItemsShow = this.sectionContainer.querySelectorAll('.media-gallery__thumbnail-item.is-show-thumbnail-item');
            if (window.innerWidth < MIN_DEVICE_WIDTH.tablet) {
              const thumbnailNavWrapperWidth = this.$refs.thumbnail_wrapper.getBoundingClientRect().width;
              const thumbnailWrapperWidth = this.thumbnailItemsShow[0]?.getBoundingClientRect().width * this.thumbnailItemsShow.length + parseFloat(getComputedStyle(this.thumbnailContainer).gap) * (this.thumbnailItems.length - 1);

              if (thumbnailWrapperWidth <= thumbnailNavWrapperWidth - 16 * 2) {
                thumbnailNavs.forEach(nav => {
                  nav.classList.add('hidden');
                })
              } else {
                thumbnailNavs.forEach(nav => {
                  nav.classList.remove('hidden');
                })
              }
            } else {
              const thumbnailNavWrapperHeight = this.$refs.thumbnail_wrapper.getBoundingClientRect().height
              let thumbnailItemsHeight = 0;
              this.thumbnailItemsShow.forEach(item => {
                thumbnailItemsHeight += item.offsetHeight;
              });
              thumbnailItemsHeight += parseFloat(getComputedStyle(this.thumbnailContainer).gap) * (this.thumbnailItemsShow.length - 1);
              if (thumbnailItemsHeight <= thumbnailNavWrapperHeight - 32 * 2) {
                thumbnailNavs.forEach(nav => {
                  nav.classList.add('md:hidden');
                })
              } else {
                thumbnailNavs.forEach(nav => {
                  nav.classList.remove('md:hidden');
                })
              }
            }
          }
        }
      }))
    })
  })
}
